import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  Switch,
  Textarea,
  useTheme,
} from "@chakra-ui/react";
import { useState } from "react";
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import Select from "react-select";
// import { FixedSizeList as List } from "react-window";

// const height = 45;
// const MenuList = (props:any) => {
//   const { options, children, getValue } = props;
//   const [value] = getValue();
//   const initialOffset = options.indexOf(value) * height;

//   return (
//     <List
//       height={height * 5}
//       itemCount={children.length}
//       itemSize={height}
//       initialScrollOffset={initialOffset}
//       width={'100%'}
//     >
//       {({ index, style }) => <Box style={style}>{children[index]}</Box>}
//     </List>
//   );
// };
interface CustomInputProps {
  type?:
    | "editor"
    | "password"
    | "number"
    | "text"
    | "file"
    | "switch"
    | "textarea"
    | "select"
    | "date"
    | "phone"
    | "time"
    | "email"
    | "file-drag";
  label?: string;
  fontSize?: string | object;
  placeholder?: string;
  required?: boolean;
  isReadOnly?: boolean;
  isRequired?: boolean;
  error?: any;
  maxDate?: any;
  minDate?: any;
  onKeyDown?: any;
  disabledDates?: any;
  name: string;
  isClear?: boolean;
  onChange?: (value: any) => void;
  value?: any;
  w?: string | object;
  h?: string | object;
  options?: any[];
  isSearchable?: boolean;
  isMulti?: boolean;
  getOptionLabel?: (option: any) => string;
  getOptionValue?: (option: any) => any;
  rows?: number;
  disabled?: boolean;
  showError?: boolean;
  style?: any;
  phone?: string;
  className?: string;
  // Callback for file drop
  onFileDrop?: (files: FileList) => void;
  props?: any;
  rest?: any;
  size?: string;
  color?: string;
  isDisabled?: boolean;
  pr?: string;
  mr?: string;
  mt?: string | number;
  mb?: string | number;
  floating?: boolean;
  minH?: string | number;
  selectWidth?: string;
}

const CustomInput = ({
  type,
  fontSize,
  label,
  placeholder,
  error,
  selectWidth = "100%",
  name,
  value,
  onChange,
  required,
  isReadOnly,
  isRequired,
  isDisabled,
  isClear,
  options,
  isSearchable,
  isMulti,
  onKeyDown,
  getOptionLabel,
  getOptionValue,
  disabled,
  rows,
  style,
  className,
  showError,
  maxDate,
  minDate,
  disabledDates,
  phone,
  w,
  h,
  pr,
  mr,
  mt,
  mb,
  onFileDrop,
  props,
  // Added onFileDrop prop
  rest,
  size,
  color,
  floating,
  minH,
}: CustomInputProps) => {
  const theme = useTheme();

  const [showPassword, setShowPassword] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  // rgb(33, 173, 232)

  const customStyle = {
    control: (provided: any, state: any) => ({
      ...provided,
      width: selectWidth,
      maxHeight: "60px",
      overflowY: "auto",
      [`@media screen and (max-width: ${theme.breakpoints.md})`]: {
        ...rest,
      },
      border: "1px solid #38B2AC",
      "&:hover": {
        border: "2px solid #21ADE8",
      },
      color: "white",
      fontSize: "16px",
      // width:"10rem",

      fontWeight: "400",
      // height: "38px",
      paddingLeft: "1rem",
      boxShadow: "none",
      backgroundColor: "transparent",
      outline: "none",

      "min-height": minH ? minH : "38px",
    }),

    option: (provided: any, state: any) => ({
      ...provided,
      fontSize: "16px",
      outline: "none",
      "&:hover": {
        backgroundColor: "#21ADE8",
      },
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      padding: "2px 0px",
      outline: "none",
    }),

    multiValue: (styles: any) => {
      return {
        ...styles,
        color: "white",
        backgroundColor: "#21ADE8",
      };
    },
    clearIndicator: (provided: any) => ({
      ...provided,
      position: "absolute",
      top: 0,
      right: 0,
      cursor: "pointer",
      // marginLeft: "0.5rem",
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
      position: "relative",
      border: "none",
    }),
    multiValueLabel: (styles: any) => ({
      ...styles,
      color: "white",
      fontWeight: "500",
    }),
    multiValueRemove: (styles: any) => ({
      ...styles,
      marginLeft: "0.5rem",
      color: "white",
      backgroundColor: "#F56565",
      ":hover": {
        backgroundColor: "#E53E3E",
        color: "white",
      },
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 9999, // Ensure this value is higher than the z-index of the Chakra UI Popover
    }),
    ...rest,
  };
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };
  // const handleFileDrop = useCallback(
  //   (event: React.DragEvent<HTMLDivElement>) => {
  //     event.preventDefault();
  //     const files = event.dataTransfer.files;
  //     console.log(files);
  //     if (onFileDrop) {
  //       onFileDrop(files);
  //     }
  //   },
  //   [onFileDrop]
  // );
  const renderInputComponent = () => {
    switch (type) {
      case "password":
        return (
          <Input
            type={showPassword ? "text" : "password"}
            pr="4.5rem"
            position="relative"
            fontSize="sm"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            name={name}
            required={required}
            isRequired={isRequired}
            disabled={disabled}
            {...rest}
          />
        );
      case "number":
        return (
          <Input
            w={w}
            type="number"
            fontSize="sm"
            value={value}
            onChange={onChange}
            name={name}
            placeholder={placeholder}
            disabled={disabled}
            isDisabled={isDisabled}
            className={className}
            size={size}
            {...rest}
          />
        );
      case "date":
        return (
          <Input
            type="date"
            style={style}
            value={value}
            onChange={onChange}
            name={name}
            {...rest}
          />
        );

      case "text":
        return (
          <Input
            type="text"
            fontSize="sm"
            placeholder={floating ? "" : placeholder}
            value={value}
            onChange={onChange}
            isReadOnly={isReadOnly}
            name={name}
            disabled={disabled}
            isDisabled={isDisabled}
            style={style}
            onKeyDown={onKeyDown}
            pr={pr}
            mr={mr}
            {...rest}
          />
        );
      case "textarea":
        return (
          <Textarea
            style={style}
            h={h}
            rows={rows || 3}
            placeholder={floating ? "" : placeholder}
            value={value}
            onChange={onChange}
            name={name}
            disabled={disabled}
            _placeholder={{ fontSize: "14px" }}
            {...rest}
          />
        );

      case "select":
        return (
          <FormControl id="select" variant="floating">
            <Select
              options={options}
              placeholder={placeholder || undefined}
              value={selectedValue}
              onChange={(value: any) => {
                setSelectedValue(value);
                if (onChange) {
                  onChange(value);
                }
              }}
              isMulti={isMulti}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary: "#38B2AC",
                  primary25: "#21ADE8",
                  primary50: "#21ADE8",
                },
              })}
              menuPosition={"fixed"}
              isSearchable={isSearchable}
              getOptionLabel={getOptionLabel}
              getOptionValue={getOptionValue}
              isDisabled={disabled}
              components={{
                IndicatorSeparator: null,
                DropdownIndicator: () => (
                  <div className="chakra-select__dropdown-indicator" />
                ),
                // MenuList
              }}
              men
              styles={customStyle}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              {...rest}
            />
            <FormHelperText
              style={{
                position: "absolute",
                zIndex: 2,
                backgroundColor: "#f8f9fa",
                left: "20px",
                fontSize: "14px",
                fontWeight: "500",
                top: selectedValue || isFocused ? "-18px" : "30%",
                transition: "top 0.3s",
                transform:
                  selectedValue || isFocused ? "none" : "translateY(-50%)",
              }}
            >
              {label}
            </FormHelperText>
          </FormControl>
        );
      case "file":
        return (
          <Input
            style={style}
            type="file"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            name={name}
            disabled={disabled}
            _placeholder={{ fontSize: "12px" }}
            {...rest}
            className="chooseFile"
          />
        );
      case "switch":
        return <Switch name={name} {...rest} />;
      default:
        return (
          <Input
            type="text"
            fontSize="sm"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            name={name}
            disabled={disabled}
            {...rest}
          />
        );
    }
  };

  return floating ? (
    <FormControl
      variant="floating"
      id={name}
      isRequired={isRequired}
      isInvalid={!!error}
      mt={mt}
      mb={mb}
    >
      {renderInputComponent()}

      {type !== "select" && (
        <FormLabel color={color} fontSize="md">
          {label}
        </FormLabel>
      )}
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  ) : (
    <FormControl
      id={name}
      isRequired={isRequired}
      isInvalid={!!error}
      mt={mt}
      mb={mb}
    >
      {type !== "select" && (
        <FormLabel color={color} fontSize="sm">
          {label}
        </FormLabel>
      )}
      <div style={{ position: "relative" }}>
        {renderInputComponent()}
        {type === "password" && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "0.75rem",
              transform: "translateY(-50%)",
              cursor: "pointer",
            }}
            onClick={handleTogglePassword}
          >
            {showPassword ? (
              <RiEyeOffLine size={18} />
            ) : (
              <RiEyeLine size={18} />
            )}
          </div>
        )}
      </div>
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  );
};

export default CustomInput;
